import Glide from '@glidejs/glide';
import BaseFeature from '../../foundation/base/base';

class CourseSlide extends BaseFeature {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.el = element;
		this.header = this.el;

		this.courseControls = this.el.querySelector('[data-glide-el="controls"]');
		this.courseListItem = this.el.querySelectorAll('[data-js="courseListItem"]');
		this.sliderWrapper = this.el.querySelectorAll('[data-js="courseSlideyWrapper"]');
		this.isHidden = 'o-course-slide--hidden';

		this.addEventListener();
	}


	addEventListener() {
		// For further API options please check the Doc at the authors adress: https://glidejs.com/docs/options/
		// Initializinbg the API

		const sliders = this.sliderWrapper;
		for (let i = 0; i < sliders.length; i++) {
			const glide = new Glide(sliders[i], {
				gap: 15,
				dragThreshold: true,
				bound: true,
				type: 'slider',
				perView: 3,
				breakpoints: {
					800: {
						perView: 2,
					},
					640: {
						perView: 1.5
					}
				}
			});

			glide.mount();
		}

		if (this.el) {
			this.el.parentNode.classList.add('has-slider');
		}

		if (this.courseControls && this.courseListItem && this.courseListItem.length <= 3) {
			this.courseControls.classList.add(this.isHidden);
		}
	}
}

export default CourseSlide;
